export function formatDateByLocale(date, locale = 'en_GB') {//it_IT
  if (!(date instanceof Date)) return '';

  const normalizedLocale = locale.replace('_', '-');


  const options = {
    year: 'numeric',
    month: 'long', // "ottobre" / "October"
    day: 'numeric'
  };

  try {
    return new Intl.DateTimeFormat(normalizedLocale, options).format(date);
  } catch (e) {
    // fallback in caso di locale non supportato
    console.warn(`Locale non valido: ${locale}, uso en-GB come fallback`);
    return new Intl.DateTimeFormat('en-GB', options).format(date);
  }
}

// for fetch markers on map
export function getTodayAsString() {
  const now = new Date();

  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, '0'); // mesi 1–12
  const dd = String(now.getDate()).padStart(2, '0');     // giorni 01–31

  return `${yyyy}${mm}${dd}`; // es: "20251020"
}